import VConsole from "vconsole";
var apiHost = $$API;
var aurl = "";

if (PROCESS.ENV != "production") {
  //非线上环境
  new VConsole();
}

var conf = {
  aurl: aurl,
  sexp: 365 * 24 * 3600,
  api: {
    //获取公众号信息
    wechatconfig: `${apiHost}/login/jsapi/signature`,

    // 静默授权
    // 获取openid
    getWxUserInfoByCode: `${apiHost}/login/mp`,

    // 获取成员列表
    getMemberList: `${apiHost}/mp/family/members/get/list`,
    // 获取成员By id
    getMemberByID: `${apiHost}/mp/family/members/get`,
    // 添加成员
    addMember: `${apiHost}/mp/family/members/add`,
    // 修改成员By id
    editMemberByID: `${apiHost}/mp/family/members/update`,
    // 删除成员By id
    removeMemberByID: `${apiHost}/mp/family/members/remove`,

    // 获取预约详情
    getOrderInfo: `${apiHost}/mp/member/booking/list`,
    // 预约
    addOrder: `${apiHost}/mp/member/booking/add`,
    // 查询诊所-医生
    getDoctorInfo: `${apiHost}/mp/doctor/auth/queryMapList`,
    // 获取预约列表
    getAllMemberBookingList: `${apiHost}/mp/member/booking/familyBooking/page`,
    // 获取个人预约列表
    getMemberBookingList: `${apiHost}/mp/member/booking/familyBooking/get`,
    // 取消预约
    cancelMemberBooking: `${apiHost}/mp/member/booking/familyBooking/cancel`,

    // 推广人员申请
    promotionApply: `${apiHost}/mp/distribution/apply`,
    // 推广人员查询
    getPromotionApply: `${apiHost}/mp/distribution/get`,

    // 获取图形验证码次数
    smstcodenum: `${apiHost}/wx/api/getPhoneVerifyCount`,
    //获取短信验证码
    smsdcode: `${apiHost}/wx/api/smscode`,
    //获取图形验证码
    smstcode: `${apiHost}/wx/api/getValidateCode`,
    //手机绑定
    smsbind: `${apiHost}/wx/api/public/login`,
    smslogin: `${apiHost}/app/login/codeLogin`,
    // 报告解读
    listByAnalysis: `${apiHost}/app/report/listByAnalysis`,
    reportsave: `${apiHost}/app/report/save`,
  },
};

export default conf;
